import React from 'react';
import { FormattedNumber } from 'react-intl';
import { amountConfig } from '../../utils/Constants';


const FormattedAmount = ({ children, minDigits, ...props }) => {
  return (
    <FormattedNumber
      value={children}
      minimumFractionDigits={minDigits || amountConfig.minimumFractionDigits}
      {...props}
    />
  );
};

export default FormattedAmount;
